import { useState, useCallback } from 'react';
import { Overview } from '../components/Overview';
import { TaskModal } from '../components/tasks';
import { useColumnNames, useColumns, useGlobalRequirements, useGlobalRequirementsActions, useEmployees, useRoadmapActions, useScheduledTasks } from '../stores/hooks';
import { useAllTasks } from '../boardv3/hooks/useBoardMaterializedTasks';
import { recalculateSchedule } from '../stores';
import { globalTasksStore } from '../stores/globalTasksStore';
import { useTaskModalState } from '../hooks/useTaskModalState';

export function LandingOverviewView() {
  const columns = useColumnNames();
  const columnDefs = useColumns();
  const employees = useEmployees();
  const globalRequirements = useGlobalRequirements();
  const { addNewRequirement, updateRequirement, deleteRequirement } = useGlobalRequirementsActions();
  const { addTask, deleteTask, removeFromBoard, updateColumn } = useRoadmapActions();
  const scheduledTasks = useScheduledTasks();
  const tasks = useAllTasks();
  const [viewMode, setViewMode] = useState<'columns' | 'timeline'>('columns');

  const modal = useTaskModalState();

  const handleOpenAddTaskModal = useCallback((_column?: string) => {
    modal.openCreate();
  }, [modal.openCreate]);

  const handleTaskClick = useCallback((taskId: string) => {
    modal.openEdit(taskId, tasks.map(t => t.id));
  }, [tasks, modal.openEdit]);

  const handleMoveTask = useCallback((taskId: string, newColumn: string) => {
    updateColumn(taskId, newColumn);
    setTimeout(() => recalculateSchedule(), 0);
  }, [updateColumn]);

  return (
    <div className="landing-demo-view-scroll">
      <Overview
        columns={columns}
        columnDefs={columnDefs}
        employees={employees}
        globalRequirements={globalRequirements}
        onAddGlobalRequirement={addNewRequirement}
        onUpdateGlobalRequirement={updateRequirement}
        onDeleteGlobalRequirement={deleteRequirement}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
        onAddTask={handleOpenAddTaskModal}
        onTaskClick={handleTaskClick}
        onMoveTask={handleMoveTask}
      />
      <TaskModal
        isOpen={modal.isOpen}
        onClose={modal.close}
        mode={modal.mode}
        taskId={modal.taskId}
        taskHistory={modal.taskHistory}
        historyIndex={modal.historyIndex}
        onNavigate={modal.navigate}
        onAdd={(task) => { addTask(task); setTimeout(() => recalculateSchedule(), 0); }}
        onUpdate={(task) => {
          globalTasksStore.send({ type: 'task.updateTitle', taskId: task.id, title: task.title });
          globalTasksStore.send({ type: 'task.updateStartDate', taskId: task.id, startDate: task.startDate });
          globalTasksStore.send({ type: 'task.updateCategories', taskId: task.id, categoryIds: task.categoryIds ?? [] });
          globalTasksStore.send({ type: 'task.updateDescription', taskId: task.id, description: Array.isArray(task.description) ? task.description : undefined });
          globalTasksStore.send({ type: 'task.updateConsequence', taskId: task.id, consequence: Array.isArray(task.consequence) ? task.consequence : undefined });
          globalTasksStore.send({ type: 'task.updateRequiredSkills', taskId: task.id, requiredSkills: typeof task.requiredSkills === 'string' ? task.requiredSkills : undefined });
          globalTasksStore.send({ type: 'task.updateEstimateMode', taskId: task.id, estimateMode: task.estimateMode });
          globalTasksStore.send({ type: 'task.updateEstimates', taskId: task.id, defaultEstimate: task.defaultEstimate, estimates: task.estimates });
          if (task.column) updateColumn(task.id, task.column);
          recalculateSchedule();
        }}
        getTaskById={(tId) => tasks.find(t => t.id === tId)}
        getScheduledTask={(tId) => scheduledTasks.get(tId)}
        columns={columns}
        onDelete={(taskId) => { deleteTask(taskId); setTimeout(() => recalculateSchedule(), 0); }}
        onRemoveFromBoard={(taskId) => { removeFromBoard(taskId); setTimeout(() => recalculateSchedule(), 0); }}
      />
    </div>
  );
}
